interface CookieYesWindow extends Window {
  revisitCkyConsent?: () => void;
}

/**
 * Opens the CookieYes preference center.
 *
 * CookieYes is loaded by the host page (Symfony), and this web component shares that
 * window, so revisitCkyConsent() is reachable from here on every page. When it is not
 * there - script blocked, or not loaded yet - the click is left alone so the browser
 * follows the link's href, which points at the privacy policy.
 */
export const openPreferenceCenter = (event: Event): void => {
  const revisitConsent = (window as CookieYesWindow).revisitCkyConsent;

  if (typeof revisitConsent !== 'function') {
    return;
  }

  event.preventDefault();
  revisitConsent();
};
